/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React, { useState } from 'react';
import { Dialog } from '@mui/material';
import { HexColorPicker } from 'react-colorful';
import './styles.scss';
import PropTypes from 'prop-types';

/**
 * SignatureDrawPad Component
 * @returns {Element}
 * @constructor
 */
export function ColorPickerDialog({ open, onClose }) {
  const [selectedColor, setSelectedColor] = useState('FF0000');

  /**
     * Handles the closure of the color picker component and performs a callback with the selected color.
     *
     * This function calls the `onClose` callback, passing the `selectedColor` as an argument.
     */
  const handleClose = () => {
    onClose(selectedColor);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <HexColorPicker className="color-picker" color={selectedColor} onChange={setSelectedColor} />
    </Dialog>
  );
}

ColorPickerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
